import { useState } from 'react';
import { tGroupedDistrict } from '../../types';

interface DeleteDistrictModalProps {
    district: tGroupedDistrict;
    getLocationEquipmentCount: (locationId: string) => number;
    onClose: () => void;
    onConfirm: () => void;
}

export const DeleteDistrictModal = ({ district, getLocationEquipmentCount, onClose, onConfirm }: DeleteDistrictModalProps) => {
    const [confirmed, setConfirmed] = useState(false);
    const [deleting, setDeleting] = useState(false);

    const totalLocations = district.locations.length;
    const totalEquipment = district.locations.reduce((sum, loc) => sum + getLocationEquipmentCount(loc.id), 0);

    const handleDelete = async () => {
        setDeleting(true);
        await onConfirm();
        setDeleting(false);
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header modal-header-danger">
                    <h2>Delete District?</h2>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>
                <div className="modal-body">
                    <div className="modal-warning">
                        <p>
                            <strong>{district.name}</strong> contains {totalLocations} location{totalLocations !== 1 ? 's' : ''} with {totalEquipment} pieces of equipment assigned. Deleting this district will also delete its locations and unassign all equipment.
                        </p>
                    </div>
                    <label className="modal-checkbox">
                        <input type="checkbox" checked={confirmed} onChange={e => setConfirmed(e.target.checked)} />
                        I understand this will delete the district and its {totalLocations} location{totalLocations !== 1 ? 's' : ''}.
                    </label>
                </div>
                <div className="modal-footer">
                    <button className="modal-btn-cancel" onClick={onClose}>Cancel</button>
                    <button className="modal-btn-danger" onClick={handleDelete} disabled={!confirmed || deleting}>
                        {deleting ? 'Deleting...' : 'Delete District'}
                    </button>
                </div>
            </div>
        </div>
    );
};
